import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "msi-form" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = { class: "msi-content" }
const _hoisted_5 = { class: "header" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 批量打印选中选")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("导出")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("新增")
const _hoisted_9 = ["onClick"]
const _hoisted_10 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_11 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_12 = {
  class: "msi-content",
  style: {"margin-top":"0"}
}
const _hoisted_13 = { class: "header" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("新增物料")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("删除选中行")
const _hoisted_16 = { class: "dialog-footer" }
const _hoisted_17 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_18 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_19 = {
  class: "msi-form",
  style: {"padding-top":"0px"}
}
const _hoisted_20 = /*#__PURE__*/_createTextVNode("提交")
const _hoisted_21 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_22 = {
  class: "msi-content",
  style: {"padding-top":"0","margin-top":"0px"}
}
const _hoisted_23 = { class: "dialog-footer" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_26 = { class: "slot_title" }
const _hoisted_27 = { class: "title_orderNo" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", null, "计划范围", -1)

import {ref,nextTick,computed,watch} from 'vue'
    import {getCheckPlanPage,getCheckPlanOrder,addCheckPlan,editCheckPlan,deleteCheckPlan,getMaterialPage,getCheckPlanDetail,getCheckPlanRange} from '@/service/main/check/checkOrder'
    import { getMaterialInfoList } from '@/service/main/warehouse';
    import { getCheckRulesPage} from '@/service/main/check/checkRules';
    import { getAreaInfoList} from '@/service/main/warehouse';
    import { ElMessage, ElMessageBox } from 'element-plus';
    import { exportExcel } from "@/utils/exportExcel";
    import Pagination from '@/components/Pagination/index.vue'
    import print from 'print-js'
    import {useStore} from '@/store'
    import {amountFormat,formatUtcToData} from '@/utils/formate'
    
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

    const store = useStore();
    
    //盘点计划状态
    const checkStatusEnum = computed(() => store.state.login.enums.enumCheckStatus); 

    //盘点规则枚举
    const checkRulesEnum = ref<{value: string,title: string}[]>([]);

    //获取所有的盘点规则
    const getCheckRulesList = () => {
        checkRulesEnum.value = [];
        getCheckRulesPage({PageNo: 1,PageSize: 1000}).then(res => {
            if(res.code == 200) {
            const {data} = res;
            const result = data;
            if(Array.isArray(result.rows)) {
                result.rows.forEach(item => {
                    const obj = {
                        value: item.orderNo,
                        title: item.name
                    }
                    checkRulesEnum.value.push(obj);
                })
            }
            }else {
            ElMessage.error(`${res.code}:${res.message}`)
            } 
        }).catch(err => {
            ElMessage.error(err)
        })
    }

    getCheckRulesList();

    //盘点维度枚举
    const checkTypeEnum = ref<{value: number,title: string}[]>([{value: 0,title:'盘点仓库'},{value: 1,title: '盘点物料'}]);

    //仓库枚举
    const wareStoreHouseEnum = computed(() => store.state.login.enums.wareStoreHouse);

    //当亲仓库下的库区枚举
    const wareRegionEnum = ref<{value: string,title: string}[]>([]);

    //库区查询，根据仓库查询查询仓库下面库区
    const getwareRegion = () => {
        wareRegionEnum.value = [];
        getAreaInfoList({StorId: addForm.value.storehouse.wareStorehouseCode,PageNo: 1,PageSize: 1000}).then(res => {
            if(res.code == 200) {
            const {data} = res;
            const result = data;
            if(Array.isArray(result.rows)) {
                result.rows.forEach(item => {
                    const obj = {
                        value: item.code,
                        title: item.name
                    }
                    wareRegionEnum.value.push(obj);
                })
            }
            }else {
            ElMessage.error(`${res.code}:${res.message}`)
            } 
        }).catch(err => {
            ElMessage.error(err)
        })
    }
   
    //查询
    const formModel = ref({
      OrderNo: '',
      Status: '',
      PageNo: 1,
      PageSize: 10
    });

    //盘点计划列表
    let tableData = ref([]);

    //列表的数据条数
    const totalItems = ref<number>(0);

    //获取菜单列表
    const getTabelData = () => {
      getCheckPlanPage(formModel.value).then(res => {
        if(res.code == 200) {
          const {data} = res;
          const result = data;
          tableData.value = result.rows;
          totalItems.value = result.totalRows;
        }else {
          ElMessage.error(`${res.code}:${res.message}`)
        } 
      }).catch(err => {
        console.log(err)
        ElMessage.error(err)
      })
    }

    getTabelData();

    //重置搜索
    const resetForm = () => {
      formModel.value = {
        OrderNo: '',
        Status: '',
        PageNo: 1,
        PageSize: 10
      }
      getTabelData();
    }

    //选中的行
    const checkRows = ref<{id:number}[]>([]);

    // 选择
    const handleSelectionChange = (val: any) => {
      checkRows.value = val;
    }
    //导出
    const handExport = () => {
      let entozh = {
          id: "序号",
          orderNo: "盘点计划号",
          ruleNo: "规则序列号",
          ruleName: "规则名称",
          statusName: '计划状态',
          checkTypeName: '盘点类型',
          planDate: '计划盘点日期',
          createdUserName: '创建人'
        };
      exportExcel(checkRows.value, entozh, "xlsx", `盘点计划信息表${formatUtcToData(new Date().toString(),'YYYY-MM-DD hh:mm:ss')}`);
    }
    
    //打印
    const printTable = () => {
      print({
        printable: checkRows.value,
        type: 'json',
        properties: [
          { field: 'orderNo', displayName: '盘点计划号'},
          { field: 'ruleNo', displayName: '规则序列号'},
          { field: 'ruleName', displayName: '规则名称'},
          { field: 'statusName', displayName: '计划状态'},
          { field: 'checkTypeName', displayName: '盘点类型'},
          { field: 'planDate', displayName: '计划盘点日期'},
          { field: 'createdUserName', displayName: '创建人'}
        ],
        header: '<h3 style="text-align: center;">盘点计划列表</h3>',
        sytle: '.custom-h3 { color: red; }'
      })
    }

    //批量删除
    const handleBatchDelete = () => {
      const handleArr: number[] = [];
      checkRows.value.forEach(item => {
        handleArr.push(item.id);
      })
      const obj = {id: handleArr};
      ElMessageBox.confirm('是否确认删除？','提示',{
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteCheckPlan(obj).then((res: any) => {
          if(res?.code === 200) {
            ElMessage.success('删除成功')
            // 刷新列表
            getTabelData()
          }else {
            ElMessage.error(`删除失败${res?.code}:${res.message}`)
          }
        }).catch((err: any) => {
          console.log(err);
          ElMessage.error(`删除失败${err}`)
        })
      }).catch(() =>{
        ElMessage.info('已取消删除')
      })
    }

    //删除
    const deleteRole = (code: string) => {
      ElMessageBox.confirm('是否确认删除？','提示',{
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteCheckPlan({orderNo: code}).then((res: any) => {
          if(res?.code === 200) {
            ElMessage.success('删除成功')
            // 刷新列表
            getTabelData()
          }else {
            ElMessage.error(`删除失败${res?.code}:${res.message}`)
          }
        }).catch((err: any) => {
          console.log(err);
          ElMessage.error(`删除失败${err}`)
        })
      }).catch(() =>{
        ElMessage.info('已取消删除')
      })
    }
    //-------------------------盘点计划范围-------------------------
    //入库单下物料详情请求
    const detailForm = ref({
        PlanId: '',
        CheckType: '',
        PageNo: 1,
        PageSize: 10
    })

    // 物料详情抽屉
    const drawerVisible = ref(false);

    //单据号
    const orderNo = ref('');

    //打开抽屉
    const openDrawer = (scope: any = {}) => {
      //当前入库单号id
      detailForm.value.PlanId = scope.id;
      detailForm.value.CheckType = scope.checkType;
      //计划号
      orderNo.value = scope.orderNo;
      //获取物料列表
      getDetail();
      drawerVisible.value = true;
    }

    //关闭抽屉
    const handleDrawerClose = () => {
      detailForm.value = {
        PlanId: '',
        CheckType: '',
        PageNo: 1,
        PageSize: 10
      }

      deltailList.value = [];
      detailCount.value = 0;

    }

    //盘点计划范围列表
    const deltailList = ref<any[]>([]);

    //盘点计划范围数据条数
    const detailCount = ref(0);

    //盘点计划范围
    const getDetail = () => {
        getCheckPlanRange(detailForm.value).then(res =>{
            if(res.code == 200) {
                const {data} = res;
                const result = data;
                deltailList.value = result.rows;
                detailCount.value = result.totalRows;
            }else {
                ElMessage.error(JSON.stringify(`获取计划范围失败${res.code}:${JSON.stringify(res.message)}`));
            }
        }).catch(err => ElMessage.error(JSON.stringify(err)))
    }
    // ---------------添加编辑逻辑-------------------------
    //获取规则单号
    const getPlanOrder = () => {
      getCheckPlanOrder().then(res => {
        if(res.code == 200) {
          addForm.value.orderNo = res.data;
        }else {
          return ElMessage.error(`获取单盘点规则序列号失败${res.code}:${res.message}`)
        }
      }).catch(err => ElMessage.error(`获取盘点规则单号失败${err}`));
    }

    //窗口类型
    const dialogType = ref('add')

    const dialogVisible = ref(false);

    //操作表单ref
    const dialogRef = ref();
    
    //获取盘点计划明细
    const getPlanDetail = (id: number,checkType: number) => {
        getCheckPlanDetail({PlanId: id,CheckType: checkType}).then(res => {
            if(res.code == 200) {
                const {data} = res;
                const result = data;
                if(checkType == 0) {
                    addForm.value.storehouse.wareStorehouseCode = result.storehouse.wareStorehouseCode;
                    setTimeout(() => {
                        addForm.value.storehouse.wareRegionCode = Array.isArray(result.storehouse.wareRegionCode) ? result.storehouse.wareRegionCode: [];
                    },300)
                    
                }else {
                    result.materials.forEach(item => {
                        warehousOrderDetails.value.push(JSON.parse(item.jsonData))
                    })
                }
            }else {
                ElMessage.error(`获取盘点计划明细失败${res.code}:${JSON.stringify(res.message)}`)
            }
        }).catch(err => ElMessage.error(JSON.stringify(err)))
    }
    //打开窗口
    const openDialog  = (type:number,scope: any = {}) => {
      if(type == 1) {
        getPlanOrder()
        dialogType.value = 'add'
      }else if(type == 2) {
        dialogType.value = 'edit'
        const {checkType,orderNo,ruleNo,planDate,remarks} = Object.assign({},scope);
        // addForm.value = {checkType,orderNo,ruleNo,planDate,remarks}
        addForm.value.checkType = checkType;
        addForm.value.orderNo = orderNo;
        addForm.value.ruleNo = ruleNo;
        addForm.value.planDate = planDate;
        addForm.value.remarks = remarks;
        getPlanDetail(scope.id,scope.checkType);
      }else if(type == 3) {
        dialogType.value = 'detail'
        const {checkType,orderNo,ruleNo,planDate,remarks} = Object.assign({},scope);
        addForm.value.checkType = checkType;
        addForm.value.orderNo = orderNo;
        addForm.value.ruleNo = ruleNo;
        addForm.value.planDate = planDate;
        addForm.value.remarks = remarks;
        getPlanDetail(scope.id,scope.checkType);
      }
      dialogVisible.value = true;
      nextTick(() => {
        dialogRef.value.clearValidate();
      })
    }

    //添加/编辑
    let addForm = ref({
      orderNo: '',
      ruleNo: '',
      planDate: '',
      remarks: '',
      checkType: 0,
      materials: [] as {wareMaterialCode: string,batchNo: string}[],
      storehouse: {
          wareStorehouseCode: '',
          wareRegionCode: [] as string[]
      }

    })

    //监视库区的选择变化，获取当前仓库下的库区列表
    watch(() => addForm.value.storehouse.wareStorehouseCode,(value) => {
        addForm.value.storehouse.wareRegionCode = [];
        if(value) {
            getwareRegion();
        }else { //如果清空了库区,库位信息为空
            wareRegionEnum.value = [];
        }
    })

    //日期选择不能大于当前时间
    const disabledDate = (time: Date) => {
      return  time.getTime() <= Date.now();
    }

    //rules
    const formRules = {
      orderNo: [{required: true,message: '盘点计划号不能为空',trigger: 'blur'}],
      ruleNo: [{required: true,message: '盘点规则不能为空',trigger: 'blur'}],
      planDate: [{required: true,message: '盘点计划日期不能为空',trigger: 'blur'}],
      checkType: [{required: true,message: '盘点维度不能为空',trigger: 'blur'}],
    }

    //操作提交
    const confirm = () => {
        addForm.value.materials = warehousOrderDetails.value;
        addForm.value.materials.map(item => {
            item.jsonData = JSON.stringify(item)
            return item;
        })
        dialogRef.value.validate((vali: any) => {
            if(vali) {
              //添加
              if(dialogType.value == 'add') {
                  addCheckPlan(addForm.value).then(res => {
                  if(res.code == 200) {
                      ElMessage.success('添加成功');
                      getTabelData();
                      dialogVisible.value = false;
                  }else {
                      ElMessage.error(`${res.code}:${res.message}`)
                  }
                  }).catch(err => {
                  console.log(err)
                  })
              }else if(dialogType.value == 'edit') {
                  editCheckPlan(addForm.value).then(res => {
                  if(res.code == 200) {
                      ElMessage.success('编辑成功');
                      getTabelData();
                      dialogVisible.value = false;
                  }else {
                      ElMessage.error(`${res.code}:${res.message}`)
                  }
                  }).catch(err => {
                  console.log(err)
                  })
              }else {
                dialogVisible.value = false;
              }
            }else {
              ElMessage.warning('表单验证失败');
            }
        })
      
    }
  
    //关闭窗口
    const closeDialog = () => {
        addForm.value = {
            orderNo: '',
            ruleNo: '',
            planDate: '',
            remarks: '',
            checkType: 0,
            materials: [] as {wareMaterialCode: string,batchNo: string}[],
            storehouse: {
                wareStorehouseCode: '',
                wareRegionCode: [] as string[]
            }
        }

        warehousOrderDetails.value = [];
        checkedDetails.value = [];
        detailRef.value.clearSelection();

    }

    // ---------------材料盘点列表-------------------------
    //物料详情的table ref
    const detailRef= ref();

    //添加编辑窗口物料列表
    const warehousOrderDetails = ref<any[]>([]);

    //物料详情列表选中的物料
    const checkedDetails = ref<any[]>([]);

    //物料详情列表中勾选事件
    const detailsCheckChange = (val: any) => {
      checkedDetails.value = val;
    }

    //删除选中的物料详情
    const delCheckedDetails = () => {
      ElMessageBox.confirm('是否确认删除？','提示',{
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        checkedDetails.value.forEach(item => {
          const index = warehousOrderDetails.value.findIndex(detail => detail.code == item.code);
          warehousOrderDetails.value.splice(index,1);
        })
      }).catch(() => ElMessage.info('已取消删除'))
      
    }

    // -----------------添加物料操作-------------------------
    //物料基础数据窗口
    const addMaterialVisible = ref(false);

    //物料基础数据列表
    const materialList = ref([])

    //物料基础数据条数
    const materialTotal = ref(0);
    
    //物料基础数据form
    const materialForm = ref({
      WareMaterialCode: '',
      WareMaterialName: '',
      BatchNo: '',
      PageNo: 1,
      PageSize: 10
    })

    //获取物料基础列表
    const getMaterialList = () => {
      getMaterialPage(materialForm.value).then(res => {
        if(res.code == 200) {
          const {data} = res;
          const result = data;
          materialList.value = result.rows;
          materialTotal.value = result.totalRows;
        }else {
          ElMessage.error(`${res.code}:${JSON.stringify(res.message)}`)
        } 
      }).catch(err => {
        console.log(err)
        ElMessage.error(JSON.stringify(err))
      })
    }

    //重置物料
    const resetMaterialForm = () => {
      materialForm.value = {
        WareMaterialCode: '',
        WareMaterialName: '',
        BatchNo: '',
        PageNo: 1,
        PageSize: 10
      }
      getMaterialList();
    }

    //选中的基础物料数据
    const checkedMaterial = ref<any[]>([]);

    //物料基础数据勾选
    const materialSelectionChange = (val: any) => {
      checkedMaterial.value = val;
    }

    //打开新增物料窗口
    const addMaterialDialog = () => {
      getMaterialList();
      addMaterialVisible.value = true;
    }
    
    //基础物料table的ref对象
    const materialRef = ref();

    //确认添加材料
    const confirmAddMaterial = () => {
      //物料列表没数据，直接添加
      if(warehousOrderDetails.value.length == 0) {
        warehousOrderDetails.value.push(...checkedMaterial.value);
      }else {
        for(let i =0;i< checkedMaterial.value.length;i++) {
          let idx = warehousOrderDetails.value.findIndex((item: { wareMaterialCode: string,batchNo: string }) => item.wareMaterialCode + item.batchNo == checkedMaterial.value[i].wareMaterialCode + checkedMaterial.value[i].batchNo)
          if(idx > -1) {
            return ElMessage.warning(`物料编号:${checkedMaterial.value[i].wareMaterialCode},批次:${checkedMaterial.value[i].batchNo}在物料列表中已存在,请去除勾选`)
          }
        }
        warehousOrderDetails.value.push(...checkedMaterial.value);
      }
        
      addMaterialVisible.value = false;
    }

    //关闭新增物料窗口
    const closeMaterialDialog = () => {
       materialForm.value = {
        WareMaterialCode: '',
        WareMaterialName: '',
        BatchNo: '',
        PageNo: 1,
        PageSize: 10
      }
      materialList.value = [];
      checkedMaterial.value = [];
      materialRef.value.clearSelection();

    }

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_form, {
        model: formModel.value,
        "label-width": "120px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "盘点计划号:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formModel.value.OrderNo,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formModel.value.OrderNo) = $event)),
                        clearable: "",
                        placeholder: "请输入盘点计划号"
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "计划状态:" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: formModel.value.Status,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formModel.value.Status) = $event)),
                        clearable: "",
                        placeholder: "请选择盘点计划状态",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(checkStatusEnum), (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item.value,
                              value: item.value,
                              label: item.title
                            }, null, 8, ["value", "label"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, { span: 6 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_button, {
                        type: "primary",
                        icon: "el-icon-search",
                        onClick: getTabelData
                      }, {
                        default: _withCtx(() => [
                          _hoisted_2
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_button, {
                        icon: "el-icon-refresh-right",
                        onClick: resetForm
                      }, {
                        default: _withCtx(() => [
                          _hoisted_3
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model"])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            type: "info",
            icon: "iconfont icon-biaoqianguanli",
            plain: "",
            disabled: checkRows.value.length == 0,
            onClick: printTable
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }, 8, ["disabled"])
        ]),
        _createElementVNode("div", null, [
          _createVNode(_component_el_button, {
            type: "info",
            plain: "",
            icon: "el-icon-upload2",
            disabled: checkRows.value.length == 0,
            onClick: handExport
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["disabled"]),
          _createVNode(_component_el_button, {
            type: "primary",
            icon: "el-icon-plus",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (openDialog(1)))
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          })
        ])
      ]),
      _createVNode(_component_el_table, {
        data: _unref(tableData),
        border: "",
        style: {"width":"100%"},
        onSelectionChange: handleSelectionChange,
        size: "mini"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, { type: "expand" }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_form, {
                "label-position": "left",
                "label-width": "180px",
                inline: "",
                class: "demo-table-expand"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_form_item, { label: "备注" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(scope.row.remarks), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_form_item, { label: "创建时间" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(scope.row.createdTime), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_form_item, { label: "创建人" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(scope.row.createdUserName), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_form_item, { label: "修改日期" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(scope.row.updatedTime), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_form_item, { label: "修改人" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(scope.row.updatedUserName), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_el_form_item, { label: "驳回理由" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", null, _toDisplayString(scope.row.rejectMsg), 1)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            align: "center",
            width: "60",
            type: "selection"
          }),
          _createVNode(_component_el_table_column, {
            label: "序号",
            align: "center",
            width: "60",
            type: "index"
          }),
          _createVNode(_component_el_table_column, {
            label: "盘点计划号",
            prop: "orderNo",
            align: "center",
            "show-overflow-tooltip": ""
          }, {
            default: _withCtx((scope) => [
              _createElementVNode("span", {
                onClick: ($event: any) => (openDialog(3,scope.row)),
                class: "under_line"
              }, _toDisplayString(scope.row.orderNo), 9, _hoisted_9)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "规则序列号",
            prop: "ruleNo",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "规则名称",
            prop: "ruleName",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "计划状态",
            prop: "statusName",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "计划盘点日期",
            prop: "planDate",
            sortable: "",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "创建日期",
            prop: "createdTime",
            sortable: "",
            align: "center",
            "show-overflow-tooltip": ""
          }),
          _createVNode(_component_el_table_column, {
            label: "操作",
            width: "220px",
            align: "center"
          }, {
            default: _withCtx((scope) => [
              _createVNode(_component_el_button, {
                type: "info",
                plain: "",
                size: "small",
                class: "el-icon-edit",
                disabled: scope.row.status == 1,
                onClick: ($event: any) => (openDialog(2,scope.row))
              }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 2
              }, 1032, ["disabled", "onClick"]),
              _createVNode(_component_el_button, {
                type: "info",
                plain: "",
                size: "small",
                class: "el-icon-delete",
                disabled: scope.row.status == 1,
                onClick: ($event: any) => (deleteRole(scope.row.orderNo))
              }, {
                default: _withCtx(() => [
                  _hoisted_11
                ]),
                _: 2
              }, 1032, ["disabled", "onClick"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"]),
      _createVNode(Pagination, {
        total: totalItems.value,
        page: formModel.value.PageNo,
        "onUpdate:page": _cache[3] || (_cache[3] = ($event: any) => ((formModel.value.PageNo) = $event)),
        limit: formModel.value.PageSize,
        "onUpdate:limit": _cache[4] || (_cache[4] = ($event: any) => ((formModel.value.PageSize) = $event)),
        onPagination: getTabelData,
        style: {"margin-top":"20px","text-align":"center"}
      }, null, 8, ["total", "page", "limit"])
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: dialogVisible.value,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((dialogVisible).value = $event)),
      title: dialogType.value == 'add' ? '添加盘点计划': '编辑盘点计划',
      width: "60%",
      onClose: closeDialog
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_16, [
          _createVNode(_component_el_button, {
            onClick: _cache[12] || (_cache[12] = ($event: any) => (dialogVisible.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_17
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: confirm
          }, {
            default: _withCtx(() => [
              _hoisted_18
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _unref(addForm),
          "label-width": "120px",
          ref_key: "dialogRef",
          ref: dialogRef,
          rules: formRules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "盘点计划号:",
                      prop: "orderNo"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(addForm).orderNo,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(addForm).orderNo) = $event)),
                          clearable: "",
                          disabled: "",
                          placeholder: "请输入盘点计划号"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "盘点规则:",
                      prop: "ruleNo"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(addForm).ruleNo,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(addForm).ruleNo) = $event)),
                          clearable: "",
                          disabled: dialogType.value == 'detail',
                          placeholder: "请选择盘点规格",
                          size: "large",
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(checkRulesEnum.value, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.title,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "盘点日期:",
                      prop: "planDate"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _unref(addForm).planDate,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_unref(addForm).planDate) = $event)),
                          type: "date",
                          disabled: dialogType.value == 'detail',
                          format: "YYYY-MM-DD",
                          "value-format": "YYYY-MM-DD",
                          clearable: "",
                          placeholder: "请选择日期",
                          "disabled-date": disabledDate,
                          style: {"width":"100%"}
                        }, null, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "备注" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: _unref(addForm).remarks,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(addForm).remarks) = $event)),
                          clearable: "",
                          disabled: dialogType.value == 'detail',
                          placeholder: "请输入计划备注"
                        }, null, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "盘点维度:",
                      prop: "checkType"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(addForm).checkType,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(addForm).checkType) = $event)),
                          clearable: "",
                          disabled: dialogType.value == 'detail',
                          placeholder: "请选择盘点维度",
                          size: "large",
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(checkTypeEnum.value, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.title,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _withDirectives(_createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "选择仓库:" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(addForm).storehouse.wareStorehouseCode,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(addForm).storehouse.wareStorehouseCode) = $event)),
                          clearable: "",
                          disabled: dialogType.value == 'detail',
                          placeholder: "请选择需要盘点的仓库",
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(wareStoreHouseEnum), (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.title,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _unref(addForm).checkType == 0]
                ]),
                _withDirectives(_createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "选择库区:" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: _unref(addForm).storehouse.wareRegionCode,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(addForm).storehouse.wareRegionCode) = $event)),
                          clearable: "",
                          disabled: dialogType.value == 'detail',
                          placeholder: "请选择需要盘点的库区",
                          multiple: "",
                          "collapse-tags": "",
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(wareRegionEnum.value, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                key: item.value,
                                label: item.title,
                                value: item.value
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 512), [
                  [_vShow, _unref(addForm).checkType == 0]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]),
        _withDirectives(_createElementVNode("div", _hoisted_12, [
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", null, [
              (!dialogType.value == 'detail')
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 0,
                    type: "primary",
                    icon: "el-icon-plus",
                    onClick: addMaterialDialog
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (!dialogType.value == 'detail')
                ? (_openBlock(), _createBlock(_component_el_button, {
                    key: 1,
                    type: "info",
                    icon: "el-icon-delete",
                    plain: "",
                    disabled: checkedDetails.value.length == 0,
                    onClick: delCheckedDetails
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 1
                  }, 8, ["disabled"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode(_component_el_table, {
            data: warehousOrderDetails.value,
            border: "",
            style: {"width":"100%"},
            "row-key": "id",
            ref_key: "detailRef",
            ref: detailRef,
            onSelectionChange: detailsCheckChange
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                align: "center",
                width: "60",
                "reserve-selection": "",
                type: "selection"
              }),
              _createVNode(_component_el_table_column, {
                label: "序号",
                align: "center",
                width: "60",
                type: "index"
              }),
              _createVNode(_component_el_table_column, {
                label: "物料编号",
                prop: "wareMaterialCode",
                align: "center",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                label: "物料名称",
                prop: "wareMaterialName",
                align: "center",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                label: "库存数量",
                prop: "occQuantity",
                align: "center",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                label: "价格",
                align: "center"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(_unref(amountFormat)(scope.row.price + '',2,false)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "总价",
                align: "center"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(_unref(amountFormat)(scope.row.price * scope.row.occQuantity + '',2,false)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "单位",
                prop: "unit",
                align: "center",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                label: "条码",
                prop: "barCode",
                align: "center",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                label: "批次",
                prop: "batchNo",
                align: "center",
                "show-overflow-tooltip": ""
              })
            ]),
            _: 1
          }, 8, ["data"])
        ], 512), [
          [_vShow, _unref(addForm).checkType == 1]
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: addMaterialVisible.value,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((addMaterialVisible).value = $event)),
      title: "添加物料详情",
      width: "60%",
      onClose: closeMaterialDialog
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_23, [
          _createVNode(_component_el_button, {
            onClick: _cache[19] || (_cache[19] = ($event: any) => (addMaterialVisible.value = false))
          }, {
            default: _withCtx(() => [
              _hoisted_24
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: confirmAddMaterial
          }, {
            default: _withCtx(() => [
              _hoisted_25
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_el_form, {
            model: materialForm.value,
            "label-width": "90px",
            size: "large"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_col, { span: 8 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { label: "物料编号:" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: materialForm.value.WareMaterialCode,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((materialForm.value.WareMaterialCode) = $event)),
                            placeholder: "请输入物料编号",
                            clearable: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 8 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { label: "物料名称:" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: materialForm.value.WareMaterialName,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((materialForm.value.WareMaterialName) = $event)),
                            placeholder: "请输入物料名称",
                            clearable: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 8 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, { label: "批次:" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: materialForm.value.BatchNo,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((materialForm.value.BatchNo) = $event)),
                            placeholder: "请输入物料批次",
                            clearable: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_col, { span: 8 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_form_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            icon: "el-icon-search",
                            onClick: getMaterialList
                          }, {
                            default: _withCtx(() => [
                              _hoisted_20
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_button, {
                            icon: "el-icon-refresh-right",
                            onClick: resetMaterialForm
                          }, {
                            default: _withCtx(() => [
                              _hoisted_21
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _createElementVNode("div", _hoisted_22, [
          _createVNode(_component_el_table, {
            data: materialList.value,
            border: "",
            style: {"width":"100%"},
            "row-key": "id",
            ref_key: "materialRef",
            ref: materialRef,
            onSelectionChange: materialSelectionChange
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_table_column, {
                align: "center",
                width: "60",
                "reserve-selection": "",
                type: "selection"
              }),
              _createVNode(_component_el_table_column, {
                label: "序号",
                align: "center",
                width: "60",
                type: "index"
              }),
              _createVNode(_component_el_table_column, {
                label: "物料编号",
                prop: "wareMaterialCode",
                align: "center",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                label: "物料名称",
                prop: "wareMaterialName",
                align: "center",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                label: "库存数量",
                prop: "occQuantity",
                align: "center",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                label: "价格",
                align: "center"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(_unref(amountFormat)(scope.row.price + '',2,false)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "总价",
                align: "center"
              }, {
                default: _withCtx((scope) => [
                  _createTextVNode(_toDisplayString(_unref(amountFormat)(scope.row.price * scope.row.occQuantity + '',2,false)), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_table_column, {
                label: "单位",
                prop: "unit",
                align: "center",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                label: "条码",
                prop: "barCode",
                align: "center",
                "show-overflow-tooltip": ""
              }),
              _createVNode(_component_el_table_column, {
                label: "批次",
                prop: "batchNo",
                align: "center",
                "show-overflow-tooltip": ""
              })
            ]),
            _: 1
          }, 8, ["data"]),
          _createVNode(Pagination, {
            total: materialTotal.value,
            page: materialForm.value.PageNo,
            "onUpdate:page": _cache[17] || (_cache[17] = ($event: any) => ((materialForm.value.PageNo) = $event)),
            limit: materialForm.value.PageSize,
            "onUpdate:limit": _cache[18] || (_cache[18] = ($event: any) => ((materialForm.value.PageSize) = $event)),
            onPagination: getMaterialList,
            style: {"margin-top":"20px","text-align":"center"}
          }, null, 8, ["total", "page", "limit"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_drawer, {
      modelValue: drawerVisible.value,
      "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((drawerVisible).value = $event)),
      title: "计划范围",
      direction: "rtl",
      size: "80%",
      onClose: handleDrawerClose
    }, {
      title: _withCtx(() => [
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, _toDisplayString(orderNo.value), 1),
          _hoisted_28
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_table, {
          data: deltailList.value,
          border: "",
          striped: "",
          style: {"width":"96%","margin":"10px auto"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_table_column, {
              label: "序号",
              align: "center",
              width: "60",
              type: "index"
            }),
            _createVNode(_component_el_table_column, {
              label: "物料编号",
              prop: "wareMaterialCode",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              label: "物料名称",
              prop: "wareMaterialName",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              label: "数量",
              prop: "quantity",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              label: "单价",
              prop: "price",
              align: "center"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(_unref(amountFormat)(scope.row.price + '',2,false)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "总价",
              align: "center"
            }, {
              default: _withCtx((scope) => [
                _createTextVNode(_toDisplayString(_unref(amountFormat)(scope.row.price * scope.row.quantity + '',2,false)), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_el_table_column, {
              label: "批次",
              prop: "batchNo",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              label: "仓库",
              prop: "wareStorehouseName",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              label: "库区",
              prop: "wareRegionName",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              label: "库位名称",
              prop: "wareLocationName",
              align: "center"
            }),
            _createVNode(_component_el_table_column, {
              label: "容器编号",
              prop: "wareContainerCode",
              align: "center"
            })
          ]),
          _: 1
        }, 8, ["data"]),
        _createVNode(Pagination, {
          total: detailCount.value,
          page: detailForm.value.PageNo,
          "onUpdate:page": _cache[21] || (_cache[21] = ($event: any) => ((detailForm.value.PageNo) = $event)),
          limit: detailForm.value.PageSize,
          "onUpdate:limit": _cache[22] || (_cache[22] = ($event: any) => ((detailForm.value.PageSize) = $event)),
          onPagination: getDetail,
          style: {"margin-top":"20px","text-align":"center"}
        }, null, 8, ["total", "page", "limit"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})